import { useState, useEffect } from "react";
import axios from "axios";
import constant from "../constant";
import { getAuthHeader } from "../utils";

const hasSessionFlag = () =>
  sessionStorage.getItem(constant.keys.authSession) === "1";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(hasSessionFlag);
  const [loading, setLoading] = useState(() => !hasSessionFlag());

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/auth/session`;
        const res = await axios.get(url, getAuthHeader());
        const ok = Boolean(res.data?.status && res.data?.result?.authenticated);
        setIsAuthenticated(ok);
        if (ok) {
          sessionStorage.setItem(constant.keys.authSession, "1");
        } else {
          sessionStorage.removeItem(constant.keys.authSession);
        }
      } catch {
        if (!hasSessionFlag()) {
          setIsAuthenticated(false);
        }
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { isAuthenticated, loading };
};

export default useAuth;
